class MakerIsConfiguratorLite {
  constructor(root) {
    this.root = root;
    this.productInputs = [...root.querySelectorAll('[data-config-product]')];
    this.shape = root.querySelector('[data-config-shape]');
    this.heightField = root.querySelector('[data-config-height-field]');
    this.depthField = root.querySelector('[data-config-depth-field]');
    this.grilleField = root.querySelector('[data-config-grille]');
    this.deviceField = root.querySelector('[data-config-device]');
    this.backOpeningField = root.querySelector('[data-config-back-opening-field]');
    this.backOpening = root.querySelector('[data-config-back-opening]');
    this.backOpeningLabel = root.querySelector('[data-config-back-opening-label]');
    this.backOpeningNote = root.querySelector('[data-config-back-opening-note]');
    this.widthLabel = root.querySelector('[data-config-width-label]');
    this.depthLabel = root.querySelector('[data-config-depth-label]');

    this.productInputs.forEach((input) => input.addEventListener('change', () => this.update()));
    this.shape?.addEventListener('change', () => this.update());
    root.querySelectorAll('input[type="range"]').forEach((input) => {
      input.addEventListener('input', () => this.updateRange(input));
      this.updateRange(input);
    });
    this.update();
  }

  get productPath() {
    return this.productInputs.find((input) => input.checked)?.value || 'Access panel';
  }

  updateRange(input) {
    const output = this.root.querySelector(`[data-range-output="${input.id}"]`);
    if (output) output.textContent = `${Number(input.value).toLocaleString(undefined, { maximumFractionDigits: 2 })}"`;
  }

  update() {
    const productPath = this.productPath;
    const isRound = this.shape?.value === 'Round';
    const needsDepth = ['Niche', 'Vent', 'Device mount'].includes(productPath);
    const needsBackOpening = ['Niche', 'Device mount'].includes(productPath);
    const backOpeningSize = productPath === 'Device mount' ? '3/4' : '1/2';

    if (this.heightField) this.heightField.hidden = isRound;
    if (this.depthField) this.depthField.hidden = !needsDepth;
    if (this.grilleField) this.grilleField.hidden = productPath !== 'Vent';
    if (this.deviceField) this.deviceField.hidden = productPath !== 'Device mount';
    if (this.backOpeningField) this.backOpeningField.hidden = !needsBackOpening;
    if (this.backOpening) {
      this.backOpening.value = `Yes, centered ${backOpeningSize}" hole`;
      if (!needsBackOpening) this.backOpening.checked = false;
    }
    if (this.backOpeningLabel) {
      this.backOpeningLabel.textContent = `Add centered ${backOpeningSize}" back opening`;
    }
    if (this.backOpeningNote) {
      this.backOpeningNote.textContent = productPath === 'Device mount'
        ? 'Leave unchecked for a solid device-mount back.'
        : 'Leave unchecked for a solid niche back.';
    }
    if (this.widthLabel) this.widthLabel.textContent = isRound ? 'Diameter' : 'Width';
    if (this.depthLabel) this.depthLabel.textContent = productPath === 'Vent' ? 'Duct / body depth' : 'Depth';
  }
}

document.querySelectorAll('[data-configurator-lite]').forEach((root) => {
  if (!root.dataset.configuratorReady) {
    root.dataset.configuratorReady = 'true';
    new MakerIsConfiguratorLite(root);
  }
});
